module.exports = __webpack_public_path__ + "db031bdeaf0aa5132f574b224e6cd9ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/keurig_dr_pepper_2022_chart.png
// module id = 1691
// module chunks = 0